import { create } from 'zustand';

const STORAGE_KEY = 'sp-active-customer-id';

interface ActiveCustomerState {
  activeCustomerId: string | null;
  setActiveCustomerId: (id: string | null) => void;
  hydrateFromCandidates: (input: {
    accessibleIds: string[];
    defaultCustomerId?: string | null;
    meCustomerId?: string | null;
  }) => void;
  clear: () => void;
}

function readStored(): string | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v?.trim() || null;
  } catch {
    return null;
  }
}

function writeStored(id: string | null): void {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore quota / private mode
  }
}

export const useActiveCustomerStore = create<ActiveCustomerState>((set, get) => ({
  activeCustomerId: readStored(),
  setActiveCustomerId: (id) => {
    writeStored(id);
    set({ activeCustomerId: id });
  },
  hydrateFromCandidates: ({ accessibleIds, defaultCustomerId, meCustomerId }) => {
    if (accessibleIds.length === 0) {
      writeStored(null);
      set({ activeCustomerId: null });
      return;
    }
    const current = get().activeCustomerId;
    if (current && accessibleIds.includes(current)) return;
    const next =
      (defaultCustomerId && accessibleIds.includes(defaultCustomerId) ? defaultCustomerId : null) ||
      (meCustomerId && accessibleIds.includes(meCustomerId) ? meCustomerId : null) ||
      accessibleIds[0];
    writeStored(next);
    set({ activeCustomerId: next });
  },
  clear: () => {
    writeStored(null);
    set({ activeCustomerId: null });
  },
}));
